export const ktpMy = {
    "老师":"老师",
    "学生":"学生",
    "身份认证":"身份认证",
    "进入机构后台":"进入机构后台",
    "切换语言":"切换语言",
    "切换中文":"Switch Chinese",
    "切换英文":"Switch English",
    "消息通知":"消息通知",
    "文库":"文库",
    "账号管理":"账号管理",
    "VIP管理":"VIP管理",
    "交易记录":"交易记录",
    "消息设置":"消息设置",
    "机构用户认证":"机构用户认证",
    "账号":"账号",
    "微信":"微信",
    "邮箱":"邮箱",
    "手机号":"手机号",
    "密码":"密码",
    "退出登录":"退出登录",
    "绑定邮箱":"绑定邮箱",
    "请输入图形验证码":"请输入图形验证码",
    "年":"年",
    "月":"月",
    "超级VIP":"超级VIP",
    "机构VIP":"机构VIP",
    "机构超级VIP":"机构超级VIP",
    "到期":"到期",
    "到期头":"",
    "所授课程":"所授课程",
    "请输入教授课程名称":"请输入教授课程名称",
    "新增课程":"新增课程",
    "上传图片":"上传图片",
    "修改失败":"修改失败",
    "未选择":"未选择",
    "确定更改入学时间吗":"确定更改入学时间吗",
    "入学时间修改成功":"入学时间修改成功",
    "手动添加":"手动添加",
    "请输入专业名称":"请输入专业名称",
    "高等教育":"高等教育",
    "高职教育":"高职教育",
    "中职教育":"中职教育",
    "请输入正确的专业":"请输入正确的专业",
    "专业不能为空":"专业不能为空",
    "新增专业":"新增专业",
    "所授专业":"所授专业",
    "所学专业":"所学专业",
    "专业":"专业",
    "当前手机":"当前手机：",
    "未绑定":"未绑定",
    "新手机号":"新手机号",
    "请输入新手机号":"请输入新手机号",
    "请输入正确的手机号":"请输入正确的手机号",
    "验证并绑定":"验证并绑定",
    "请输入上方算式结果":"请输入上方算式结果",
    "请输入正确的验证码":"请输入正确的验证码",
    "绑定成功":"绑定成功",
    "更换手机号":"更换手机号",
    "绑定手机号":"绑定手机号",
    "解除绑定":"解除绑定",
    "验证并解绑":"验证并解绑",
    "解除绑定成功":"解除绑定成功",
    "解除绑定失败":"解除绑定失败",
    "已绑定":"已绑定",
    "退出成功":"退出成功",
    "确认登出此账号":"确认登出此账号?",
    "退出登录将解绑当前的微信号":"退出登录，将解绑当前的微信号",
    "个":"个",
    "头像":"头像",
    "教工号":"教工号",
    "身份":"身份",
    "院系":"院系",
    "个人资料":"个人资料",
    "图片正在插入中":"图片正在插入中...",
    "请选择图片格式的文件":"请选择图片格式的文件",
    "图片最大不能超过5MB":"图片最大不能超过5MB",
    "猜你喜欢":"猜你喜欢",
    "人阅读":"人阅读",
    "已认证的机构身份":"已认证的机构身份",
    "点击卡片即可编辑已认证身份":"点击卡片即可编辑已认证身份",
    "查看机构编排的课程":"查看机构编排的课程",
    "请填写以下信息完成身份认证":"请填写以下信息完成身份认证",
    "您所在的学校已开通机构后台功能需要完成身份认证才能同步学校为您所排的课程":"您所在的学校已开通机构后台功能，需要完成身份认证才能同步学校为您所排的课程",
    "学校机构":"学校机构",
    "请输入所在学校机构":"请输入所在学校机构",
    "请输入学校名称":"请输入学校名称",
    "取消绑定":"取消绑定",
    "请输入姓名":"请输入姓名",
    "请输入学号":"请输入学号",
    "请输入教工号":"请输入教工号",
    "以后再说":"以后再说",
    "取消本次认证":"取消本次认证",
    "确认认证":"确认认证",
    "学校已为您进行排课新增排课课程如下您可以选择已经创建的课程绑定排课课程":"学校已为您进行排课，新增排课课程如下，您可以选择已经创建的课程绑定排课课程。",
    "未被绑定的排课课程将为您自动创建新课程":"未被绑定的排课课程将为您自动创建新课程。",
    "学校已为您进行排课新增排课课程如下您将自动加入以下课程":"学校已为您进行排课，新增排课课程如下，您将自动加入以下课程",
    "认证其他机构":"+ 认证其他机构",
    "选择学校机构":"选择学校机构",
    "确认自动创建课程":"确认自动创建课程?",
    "有":"有",
    "门排课课程未进行绑定":"门排课课程未进行绑定",
    "系统将自动创建对应课程":"系统将自动创建对应课程",
    "暂不创建":"暂不创建",
    "确认创建":"确认创建",
    "绑定失败":"绑定失败",
    "认证成功":"认证成功",
    "绑定课程":"绑定课程",
    "暂无课程":"暂无课程",
    "已取消账号绑定":"已取消账号绑定",
    "可在个人中心处继续完成绑定流程":"可在个人中心处继续完成绑定流程",
    "发布人":"发布人:",
    "教学活动":"教学活动",
    "教务通知":"教务通知",
    "系统通知":"系统通知",
    "申诉":"申诉",
    "互动试卷":"互动试卷",
    "忽略全部":"忽略全部",
    "消息标题":"消息标题",
    "课堂成员变动":"课堂成员变动",
    "默认周六21:30接收成员变动消息推送":"默认周六21:30接收成员变动消息推送",
    "作业到期":"作业到期",
    "作业到截止日期接收消息通知":"作业到截止日期接收消息通知",
    "课堂私信":"课堂私信",
    "有老师同学私信后接收消息推送":"有老师/同学私信后接收消息推送",
    "话题提醒":"话题提醒",
    "有老师同学发起话题后接收消息推送":"有老师/同学发起话题后接收消息推送",
    "订单编号":"订单编号：",
    "待支付":"待支付",
    "已退款":"已退款",
    "已关闭":"已关闭",
    "实付款":"实付款",
    "当前状态":"当前状态",
    "未支付":"未支付",
    "已支付":"已支付",
    "开票状态":"开票状态",
    "交易类型":"交易类型",
    "订单编号2":"订单编号",
    "请输入院系":"请输入院系",
    "请输入正确的":"请输入正确的",
    "不能为空":"不能为空",
    "当前邮箱":"当前邮箱: ",
    "更换邮箱":"更换邮箱",
    "确认解绑当前已绑定的邮箱吗":"确认解绑当前已绑定的邮箱吗？",
    "请输入新邮箱":"请输入新邮箱",
    "新邮箱":"新邮箱",
    "请输入正确的邮箱":"请输入正确的邮箱",
    "新密码":"新密码",
    "请输入新密码":"请输入新密码",
    "请再输入新密码":"请再输入新密码",
    "密码修改成功请重新登录":"密码修改成功，请重新登录",
    "密码设置":"密码设置",
    "选择学校名称":"选择学校名称",
    "请输入搜索关键词":"请输入搜索关键词",
    "当前微信":"当前微信：",
    "绑定微信":"绑定微信",
    "长按二维码进行识别绑定":"长按二维码进行识别绑定",
    "请输入加课码":"请输入加课码",
    "进入课堂":"进入课堂",
    "直达课程列表":"直达课程列表",

}
